<template>
    <v-dialog
        v-model="open"
        width="600"
        persistent>
        <v-card class="background-2 round-card">
            <v-card-title class="pa-3">
                <p class="pl-2 pl-xl-3">Upload File</p>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
                <v-container>
                    <v-row class="pb-3 px-2 pt-4">
                        <v-col class="px-4 py-0" cols="12">
                            <v-file-input
                                v-model="fileToUpload"
                                outlined dense
                                :accept="button.accept"
                                small-chips
                                v-validate="'required'"
                                required
                                data-vv-name="File"
                                :error-messages="errors.collect('File')"
                                label="File">
                            </v-file-input>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="red" @click="$emit('close')">chiudi</v-btn>
                <v-btn text color="primary" :loading="loading" @click="uploadFile()">upload</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        name: 'upload-file-dialog',
        props: {
            open: Boolean,
            attrs: Object,
            model: Object,
            params: Object,
            button: Object,
            selected: Array,
            modelDef: String,
            selectedIds: Array,
        },

        data() {
            return {
                loading: false,
                fileToUpload: null,
                uploadDialog: false,
            }
        },

        methods: {

            uploadFile() {

			    this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }

                    this.loading = true
                    var formData = new FormData()
                    formData.append('file', this.fileToUpload)

                    this.axios.post(this.button.url + '/' + (this.model ? this.model.id : ''),
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
                            this.loading = false
                            this.$eventBusUtility.$emit('refreshShow')
                            if(response.data.data && response.data.data.route) {
                                this.$router.push({ name: response.data.data.route, params: response.data.data })
                            }

                            this.$emit('close')
                    }, response => {
                        this.loading = false
                    })
				}).catch(() => {

				})                
            },
        }        
    }
</script>